import { Component, OnInit } from '@angular/core';
import { Painting } from 'src/app/models/painting.model';
import { PaintingService } from 'src/app/services/painting.service';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-editpaintings',
  templateUrl: './editpaintings.component.html',
  styleUrls: ['./editpaintings.component.scss'],
})
export class EditpaintingsComponent implements OnInit {
  paintings: Painting[];
  painting: Painting[] = [];
  id: number;
  fg: FormGroup;
  selectedFile: File = null;

  constructor(
    private _paintingService: PaintingService,
    private _builder: FormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    private _http: HttpClient
  ) { }

  ngOnInit(): void {
    this.fg = this._builder.group({
      name: ['', Validators.required],
      year: ['', Validators.required],
      description: ['', Validators.required],
      dimensions: ['', Validators.required],
      available: ['', Validators.required],
      pImage: ['']

    });

    this.id = this._route.snapshot.params['id'];
    this._paintingService
      .getById(this.id)
      .subscribe((data) => (this.painting = data));
      
  }
  onSubmit() {
    if (this.fg.invalid) {
      return;
    }
    const fd = new FormData();
    fd.append('pImage', this.selectedFile, this.selectedFile.name);
    fd.append('name', this.fg.value.name);
    fd.append('year', this.fg.value.year);
    fd.append('description', this.fg.value.description);
    fd.append('dimensions', this.fg.value.dimensions);
    fd.append('available', this.fg.value.available);

    this._http.put(`http://localhost:3100/api/paintings/${this.id}`, fd).subscribe(

      {
        next: () => {
          this._router.navigate(['/works']);
        },
      }

    );


  }

  onFileSelected(event) {
    this.selectedFile = <File>event.target.files[0];
  }
}
// import { Component, OnInit } from '@angular/core';
// import { Painting } from 'src/app/models/painting.model';
// import { PaintingService } from 'src/app/services/painting.service';
// import { FormBuilder, Validators } from '@angular/forms';
// import { ActivatedRoute, Router } from '@angular/router';
// import { FormGroup } from '@angular/forms';

// @Component({
//   selector: 'app-editpaintings',
//   templateUrl: './editpaintings.component.html',
//   styleUrls: ['./editpaintings.component.scss'],
// })
// export class EditpaintingsComponent implements OnInit {
//   paintings: Painting[];
//   painting: Painting[] = [];
//   id: number;
//   fg: FormGroup;

//   constructor(
//     private _paintingService: PaintingService,
//     private _builder: FormBuilder,
//     private _route: ActivatedRoute,
//     private _router: Router
//   ) {}

//   ngOnInit(): void {
//     this.id = this._route.snapshot.params['id'];
//     this._paintingService
//       .getById(this.id)
//       .subscribe((data) => (this.painting = data));
//     this.fg = this._builder.group({
//       name: ['', Validators.required],
//       year: ['', Validators.required],
//       dimensions: ['', Validators.required],
//       description: ['', Validators.required],
//       available: ['', Validators.required],

//     });
//   }
//   onSubmit() {
//     if (this.fg.invalid) {
//       return;
//     }
//     this._paintingService.update(this.id, this.fg.value).subscribe({
//       next: () => {
//         this._router.navigate(['/works']);
//       },
//     });
//   }
// }
